"use strict";
export { Portal } from '@ark-ui/react/portal';
